export enum RequestTypeForValidation {
	DepositElectronicMoney = 0,
	DepositMoneyCurrency = 1,
	ExchangeMoneyCurrency = 2,
	ExchangeElectronicMoney = 3,
	Point = 4,
	SendOtherWay = 5,
	SendTcWallet = 6,
	Voucher = 7,
	WithdrawalElectronicMoney = 8,
	WithdrawalMoneyCurrency = 9
}